import { useContext } from 'react'
import { DashboardContext } from '../context/Dashboard'

export const DashboardData = () => useContext(DashboardContext)
